import { IAction } from '@ads/iam-library';
import FrontendActionValidator from './FrontendActionValidator';

// vue directive factory
export default function createIamEnforcerDirective(defaultAction?: IAction['actionName']) {
    const frontendActionValidator = new FrontendActionValidator(defaultAction);
    return {
        async bind(element, binding, vnode) {
            const hasUserAccess = await frontendActionValidator.validate(binding.value, vnode.context.$root.user);

            if (!hasUserAccess) {
                element.dataset.previousDisplayStyle = element.style.display;
                element.style.display = 'none';
            }
        },

        async update(element, binding, vnode) {
            const hasUserAccess = await frontendActionValidator.validate(binding.value, vnode.context.$root.user);

            if (hasUserAccess) {
                element.style.display = element.dataset.previousDisplayStyle || 'initial';
            } else {
                element.style.display = 'none';
            }
        },
    };
}
